import React from "react";
import {claimTypes} from "../../../../constants/claim.constants";
import {Button, ButtonGroup, Spinner} from "react-bootstrap";
import HilightTable from "../../../../components/HilightTable";
import {withNamespaces} from "react-i18next";
import {modalActions} from "../../../../actions/modal.actions";
import {exhibitionScenarioActions} from "../../../../actions/exhibition-scenario.actions";
import {connect} from "react-redux";
import ExhibitionScenarioForm from "../_forms/ExhibitionScenarioForm";

const ExhibitionScenarioTable = ({t, list, user, showModal, hideModal, editScenario, deleteScenario}) => {

    const claimExhibitionScenario = user[`c_exhibition-scenario.actions.crud`] || null;

    const onEditModal = (row) => {
        showModal({
            open: true,
            title: t('edit_exhibition-scenario'),
            component: <ExhibitionScenarioForm data={row} submit={(data) => editScenario(data)}/>,
        }, 'formModal');
    }

    const onDeleteModal = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: () => {
                deleteScenario(row.id);
                hideModal();
            },
        }, 'confirm')
    };

    const columns = [
        {
            Header: '#',
            accessor: 'id',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
        },
        {
            Header: 'label',
            Cell: (props) => {
                const data = props.row.original;
                return (<b>{data.label}</b>)
            }
        },
        {
            Header: 'scenario-key',
            accessor: 'scenarioKey'
        },
        {
            Header: 'description',
            accessor: 'description',
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    claimExhibitionScenario === claimTypes.READ_WRITE ? (
                        <ButtonGroup>
                            <Button className="mx-1" variant={"primary"} onClick={() => onEditModal(data)}>
                                <i className="fas fa-edit" />
                            </Button>

                            <Button className="mx-1" variant={"danger"} onClick={() => onDeleteModal(data)}>
                                <i className="fas fa-trash" />
                            </Button>
                        </ButtonGroup>
                    ) : (t('msg.not-permission'))
                );
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('exhibition-scenario-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            {tableResult}
        </div>
    )
}
const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    },
    editScenario: (scenarioModel) => dispatch(exhibitionScenarioActions.editExhibitionScenario(scenarioModel)),
    deleteScenario: (scenarioId) => dispatch(exhibitionScenarioActions.deleteExhibitionScenario(scenarioId))
});
const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
}
export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ExhibitionScenarioTable));